// resolveBackendUrl — turn a backend-relative path (e.g. an avatar URL
// stored as "/api/avatar/file/<uid>/profile.png?v=...") into a fully
// qualified URL the iOS Capacitor WebView can actually load.
//
// On web (running at mywyngx.com), relative `/api/...` paths resolve
// against the host correctly. But in Capacitor the WebView origin is
// `capacitor://localhost`, so an `<img src="/api/...">` becomes
// `capacitor://localhost/api/...` → 404 → broken-image icon.
//
// Use this helper for any value that comes from the backend and might
// be a relative `/api/...` path: avatar_url, photo_url, share-image
// URLs, generated-image URLs, etc.
import { BACKEND_URL } from "@/api";

export function resolveBackendUrl(url) {
    if (!url || typeof url !== "string") return url;
    // Already absolute — pass through.
    if (/^https?:\/\//i.test(url)) return url;
    if (/^data:|^blob:/i.test(url)) return url;
    // Backend-relative — prefix with REACT_APP_BACKEND_URL.
    if (url.startsWith("/api/") || url.startsWith("/static/")) {
        const base = (BACKEND_URL || "").replace(/\/+$/, "");
        return base + url;
    }
    // Local SPA asset (e.g. "/heroes/foo.png", "/avatars/me-bitmoji.png")
    // — leave untouched so it resolves against the WebView origin.
    return url;
}
